import faIR from 'antd/locale/fa_IR'
import _ from "lodash";

const content = {
    Commons: {
        PendingRequest: {
            loading: "در حال دریافت اطلاعات از سرور",
        }
    },
    Layouts: {
        Dashboard: {
            Menu: {
                title: "گزینه ها",
            },
            Route: {
                dashboard: "پیشخوان",
                hostManagement: "مدیریت میزبان ها",
                host: "میزبان ها",
                userManagement: "مدیریت کاربران",
                user: "کاربران",
                role: "نقش ها",
                permission: "سطوح دسترسی",
                fileManagement: "مدیریت فایل ها",
                file: "فایل ها",
                directory: "دایرکتوری",
                basicInformation: "اطلاعات پایه",
                province: "استان ها",
                city: "شهرها",
                ticketManagement: "مدیریت بلیط ها",
                company: "شرکت ها",
                ticket: "بلیط ها",
                priority: "اولویت ها",
                price: "قیمت ها",
                profile: "اطلاعات کاربری",
                email: "پست الکترونیکی",
                mobile: "تلفن همراه",
                signOut: "خروج",
            },
        }
    },
    Pages: {
        Dashboard: {
            title: "پیشخوان",
            chartTitleSeat: "نمودار روزانه تعداد صندلی های صادر شده برای شرکت",
            chartTitleAmount: "نمودار روزانه میزان فروش ریالی برای شرکت",
            total: "در مجموع",
            seatTicket: (seat: number, ticket: number) => `${seat} صندلی در ${ticket} بلیط صادر شد.`,
        },
        Username: {
            email: "پست الکترونیکی",
            mobile: "تلفن همراه",
            oneTimeCode: "کد تایید یکبار مصرف",
            receiveCode: "دریافت کد تایید",
            captcha: "کد امنیتی",
        },
        SignIn: {
            signIn: "ورود",
            google: "ورود با گوگل",
            username: "تلفن همراه / پست الکترونیکی",
            captcha: "کد امنیتی",
            password: "کلمه عبور",
            hasPassword: "کلمه عبور خود را می دانم.",
            forgotPassword: "کلمه عبور خود را فراموش کرده ام.",
            oneTimeCode: "کد تایید یکبار مصرف",
            receiveCode: "دریافت کد تایید",
        },
        SignUp: {
            signUp: "عضویت",
            google: "عضویت با گوگل",
            firstName: "نام",
            lastName: "نام خانوادگی",
            nationalCode: "کد ملی",
            username: "تلفن همراه / پست الکترونیکی",
            captcha: "کد امنیتی",
            oneTimeCode: "کد تایید یکبار مصرف",
            receiveCode: "دریافت کد تایید",
        },
        ResetPassword: {
            resetPassword: "بازیابی کلمه عبور",
            username: "تلفن همراه / پست الکترونیکی",
            captcha: "کد امنیتی",
            password: "کلمه عبور جدید",
            confirm: "تکرار کلمه عبور جدید",
            changePassword: "تغییر کلمه عبور",
        },
        NotFound: {
            description: "متاسفانه صفحه درخواستی شما یافت نشد.",
        },
        NotAuth: {
            description: "متاسفانه شما مجوز دسترسی به این صفحه را ندارید.",
        },
        Profile: {
            profile: "اطلاعات کاربری",
            uploadTitle: "بارگذاری تصویر کاربری",
            uploadDescription: "پیشنهاد می شود ابعاد تصویر کاربری 800 در 800 پیکسل و فرمت آن حتما JPG یا PNG باشد.",
            avatar: "تصویر کاربری",
            avatarFormat: "تصویر کاربری حتما باید JPG یا PNG باشد.",
            avatarSize: "حجم تصویر کاربری حتما زیر 2 مگابایت باشد.",
            firstName: "نام",
            lastName: "نام خانوادگی",
            nationalCode: "کد ملی",
            mobile: "تلفن همراه",
            email: "پست الکترونیکی",
            password: "کلمه عبور فعلی",
            newPassword: "کلمه عبور جدید",
            confirm: "تکرار کلمه عبور جدید",
        },
        BasicInformation: {
            City: {
                name: "نام شهر",
                province: "نام استان",
            },
            Province: {
                name: "نام استان",
            },
        },
        FileManagement: {
            File: {
                originalName: "نام فایل",
                mimeType: "نوع فایل",
                size: "حجم فایل (MB)",
                createdAt: "تاریخ بارگذاری فایل",
                directory: "دایرکتوری",
            },
            Directory: {
                title: "عنوان",
                alias: "نام مستعار",
                parent: "والد",
                publish: "وضعیت",
                empty: "هیچ دایرکتوری تعریف نشده است.",
            }
        },
        HostManagement: {
            Host: {
                title: "عنوان",
                description: "توضیحات",
                host: "میزبان",
                smsTemplate: "قالب پیامک",
                favicon: "آیکون",
                verticalLogo: "لوگو عمودی",
                horizontalLogo: "لوگو افقی",
                attachmentFavicon: "محل بارگذاری فایل آیکون",
                attachmentVerticalLogo: "محل بارگذاری فایل لوگو عمودی",
                attachmentHorizontalLogo: "محل بارگذاری فایل لوگو افقی",
                addHost: "افزودن میزبان",
            },
        },
        TicketManagement: {
            Company: {
                number: "کد شرکت",
                name: "نام شرکت",
                position: "موقعیت شرکت",
                firstName: "نام نماینده شرکت",
                lastName: "نام خانوادگی نماینده شرکت",
                mobile: "تلفن همراه نماینده شرکت",
                nationalCode: "کد ملی نماینده شرکت",
                tel: "شماره تماس شرکت",
                cities: "شهرهای تحت پوشش",
                user: "اطلاعات نماینده شرکت",
                createdAt: "تاریخ ایجاد شرکت",
                updatedAt: "تاریخ ویرایش شرکت",
                addCompany: "افزودن شرکت",
            },
            Ticket: {
                date: "تاریخ صدور بلیط",
                number: "کد بلیط",
                name: "نام نام خانوادگی مسافر",
                firstName: "نام مسافر",
                lastName: "نام خانوادگی مسافر",
                mobile: "تلفن همراه مسافر",
                nationalCode: "کد ملی مسافر",
                destination: "مقصد",
                company: "نام شرکت مسافربری",
                tel: "شماره تماس شرکت مسافربری",
                seat: "تعداد صندلی",
                operator: "اپراتور",
                createdAt: "تاریخ ایجاد بلیط",
                updatedAt: "تاریخ ویرایش بلیط",
                addTicket: "ایجاد بلیط",
                capacityTitle: "در یک ساعت گذشته",
                excel: "برای گرفتن خروجی اکسل ابتدا با کمک جستجو تعدادی از بلیط ها را فیلتر کرده و سپس بر روی دکمه خروجی اکسل کلیک نمایید.",
                capacity: (seatLeft: number, carLeft: number) => `${seatLeft} صندلی در ${carLeft} اتومبیل بدون مسافر است.`,
                countTitle: "در یک ساعت گذشته",
                count: (countService: number) => `${countService} سرویس گرفته شده است.`,
                ticketTitle: "در یک ساعت گذشته",
                ticket: (ticket: number, seat: number) => `${ticket} بلیط با ظرفیت  ${seat} صندلی صادر شد.`,
                priority: (seat: number) => `${seat} صندلی درخواست دارد.`,
                outCycle: 'خارج از چرخه',
                amount: 'مبلغ قابل پرداخت',
                toman: "تومان",
            },
            Priority: {
                destination: "مقصد",
                company: "نام شرکت مسافربری",
                seat: "تعداد صندلی",
                operator: "اپراتور",
                createdAt: "تاریخ ایجاد اولویت",
                updatedAt: "تاریخ ویرایش اولویت",
                addPriority: "افزودن اولویت",
            },
            Price: {
                destination: "مقصد",
                price: "قیمت",
                createdAt: "تاریخ ایجاد قیمت",
                updatedAt: "تاریخ ویرایش قیمت",
                addPrice: "افزودن قیمت",
            },
        },
        UserManagement: {
            User: {
                firstName: "نام",
                lastName: "نام خانوادگی",
                nationalCode: "کد ملی",
                mobile: "تلفن همراه",
                email: "پست الکترونیکی",
                password: "کلمه عبور",
                confirm: "تکرار کلمه عبور",
                createdAt: "تاریخ عضویت",
                host: "میزبان",
                publish: "وضعیت",
                roles: "نقش ها",
                addRoles: "افزودن نقش ها",
            },
            Role: {
                name: "نام",
                caption: "توضیحات",
                createdAt: "تاریخ ایجاد",
                permissions: "سطوح دسترسی",
                addPermissions: "افزودن سطوح دسترسی",
            },
            Permission: {
                name: "نام",
                caption: "توضیحات",
                createdAt: "تاریخ ایجاد",
            },
            View: {
                date: 'تاریخ',
                count: 'تعداد بازدیدها',
            }
        },
    },
    Validation: {
        required: "نمی تواند خالی باشد!",
        length: "کاراکتر باید باشد.",
        pattern: "با الگو مطابقت ندارد.",
        persian: "لطفا فقط از حروف فارسی استفاده نمایید.",
        mobile: "تلفن همراه معتبر نمی باشد.",
        email: "پست الکترونیکی معتبر نمی باشد.",
        mobileOrEmail: "تلفن همراه یا پست الکترونیکی معتبر نمی باشد.",
        min: "حداقل",
        max: "حداکثر",
        passwordConfirm: "تکرار کلمه عبور صحیح نمی باشد.",
        newPasswordConfirm: "تکرار کلمه عبور جدید صحیح نمی باشد.",
    },
    Share: {
        edit: "ویرایش",
        add: "افزودن",
        multiAdd: "افزودن گروهی",
        upload: "بارگذاری فایل",
        delete: "حذف",
        download: "دانلود",
        print: "چاپ",
        copy: "رونوشت",
        save: "ذخیره",
        cancel: "انصراف",
        rial: "ریال",
        gram: "گرم",
        publish: "وضعیت",
        changePublish: "تغییر وضعیت",
        search: "جستجو",
        excel: "خروجی اکسل",
        view: "مشاهده",
        close: "بستن",
        ok: "باشه",
        confirm: "متوجه شدم",
        noFilter: "بدون فیلتر",
        active: "فعال",
        inactive: "غیر فعال",
        yes: "بله",
        no: "خیر",
        defined: "مشخص شده",
        notDefined: "مشخص نشده",
        all: "همه",
        just: "فقط",
        sms: "ارسال پیامک گروهی",
        smsYes: "همه کاربران",
        smsNo: "هیچ کاربری",
        pleaseSelectedRecord: "لطفا یک رکورد را انتخاب نمایید!",
        pleaseSelectedRecords: "لطفا یک یا چند رکورد را انتخاب نمایید!",
        editRecord: "ویرایش یک رکورد",
        addRecord: "افزودن یک رکورد",
        addOrEditRecord: "افزودن یا ویرایش یک رکورد",
        row: "ردیف",
        operation: "عملیات",
        paginationShowTotal: "مجموع آیتم ها",
        deleteConfirmTitle: "آیا شما از حذف آیتم مورد نظر اطمینان دارید؟",
        deleteConfirmOk: "بله",
        deleteConfirmCancel: "خیر",
        attachment: "محل بارگذاری فایل",
        attachmentDescription: "با کلیک و یا رها کردن فایل ها خود در این قسمت اقدام به ضمیمه کردن آن نمایید.",
        loading: "در حال بارگذاری ...",
        backDashboard: "بازگشت به پیشخوان",
    },
    Message: {
        PASSWORD_IS_INCORRECT: "کد تایید یکبار مصرف مورد تایید نمی باشد.",
        VERIFY_CODE_SENT: "کد تایید یکبار مصرف ارسال گردید.",
        SIGN_IN_PROFILE: "شما وارد حساب کاربریتان شدید.",
        SIGN_OUT_PROFILE: "شما از حساب کاربریتان خارج شدید.",
        UPDATE_PROFILE: "اطلاعات حساب کاربریتان با موفقیت ویرایش شد.",
        CHANGE_USERNAME: "تلفن همراه یا پست الکترونیکی با موفقیت ویرایش شد.",
        CHANGE_PASSWORD: "کلمه عبور با موفقیت تغییر یافت.",
        CURRENT_PASSWORD_INVALID: "کلمه عبور فعلی مورد قبول نمی باشد.",
        RESET_PASSWORD_LINK: "آدرس بازیابی کلمه عبور ارسال گردید.",
        CREATE_RECORD: "رکورد با موفقیت ایجاد گردید.",
        CREATE_RECORDS: "تمامی رکوردها با موفقیت ایجاد گردیدند.",
        UPDATE_RECORD: "رکورد با موفقیت بروزرسانی گردید.",
        UPDATE_RECORDS: "تمامی رکوردها با موفقیت بروزرسانی گردیدند.",
        DELETE_RECORD: "رکورد با موفقیت حذف گردید.",
        DELETE_FILE: "فایل با موفقیت حذف گردید.",
        UPLOAD_SUCCESS: "فایل با موفقیت بارگذاری گردید.",
        UPLOAD_ERROR: "در بارگذاری فایل خطایی روی داده است.",
        MAX_SIZE_FILE: "بیشترین حجم فایل قابل بارگذاری 2 مگابایت می باشد.",
        INVALID_FILE_FORMAT: "فرمت فایل ارسالی قابل قبول نمی باشد.",
        CAPTCHA_INVALID: "کد امنیتی صحیح نمی باشد.",
        COPY_CLIPBOARD: "رونوشتی از آدرس فایل ایجاد گردید.",
        MOBILE_OR_EMAIL_IS_MANDATORY: "تلفن همراه یا پست الکترونیکی یک فیلد اجباری می باشد.",
        "ThrottlerException: Too Many Requests": "تعداد درخواست های شما بیش از حد مجاز است.",
        "Unauthorized": "اطلاعات وارد شده مورد تایید نمی باشد.",
        "Not Found": "چنین رکوردی وجود ندارد.",
        "exist invoice for product": "برای این محصول فاکتور وجود دارد.",
        "duplicate name province": "نام استان تکراری است.",
        "duplicate mobile user": "تلفن همراه تکراری است.",
        "username or password invalid": "نام کاربری یا کلمه عبور اشتباه می باشد.",
        "old password invalid": "کلمه عبور فعلی مورد قبول نمی باشد.",
        "invalid mobile or email": "تلفن همراه یا پست الکترونیکی معتبر نمی باشد.",
        "duplicate mobile or email user": "کاربری با این تلفن همراه یا پست الکترونیکی ثبت نام کرده است.",
        "reset password token invalid": "آدرس بازیابی کلمه عبور معتبر نمی باشد.",
        "not found email address": "پست الکترونیکی معتبر نمی باشد.",
        "not found mobile number": "تلفن همراه معتبر نمی باشد.",
        "duplicate position company": "این شماره موقعیت مربوط به شرکت دیگری می باشد.",
        "duplicate destination and company": "اولویتی با این مشخصات از قبل تعریف شده است.",
        "duplicate destination price": "برای این مقصد قیمت از قبل تعریف شده است.",
    },
    Enum: {
        Payment: {
            SEP: "پرداخت الکترونیک سامان کیش",
            PEP: "پرداخت الکترونیک پاسارگاد",
            SADAD: "پرداخت الکترونیک سداد",
            ZARINPAL: "پرداخت یاری زرین پال",
        },
    },
    Dayjs: {
        monthsShort: [
            'فروردین',
            'اردیبهشت',
            'خرداد',
            'تیر',
            'مرداد',
            'شهریور',
            'مهر',
            'آبان',
            'آذر',
            'دی',
            'بهمن',
            'اسفند'
        ]
    },
}

export default _.merge(faIR, content);
